import { useState } from 'react';
import Page from './layout/Page';
import Card from "./layout/Card";
import React from 'react';
import {useLocation} from 'react-router-dom';
import {sendMessage} from '../api';
import { showError } from '../utils';
import useAlert from '../hooks/useAlert';

export default function InviaMessaggio() {
    const location = useLocation();
    
    const [messaggio, setMessaggio] = useState('');
    const alert = useAlert();

    const handleSendMessage = async () => {
        try {
            await sendMessage(messaggio);
            setMessaggio(''); // Reset the instructions after sending
            alert({message: 'Messaggio inviato con successo!'});

        } catch (e) {
            showError([e.message]);
        }
    };

    const messaggioTextarea = (
        <div className="gas-form">
            <form className="form">
                <div className="form-fields">
                    <div className="input-form">
                        <textarea
                            rows="5"
                            placeholder="Inserisci un messaggio da inviare alla segretaria"
                            value={messaggio}
                            onChange={(e) => setMessaggio(e.target.value)}
                        />
                    </div>
                </div>
            </form>
        </div>
    );


    return (
        <Page title="Invia messaggio libero">
            <Card title="Messaggio" content={messaggioTextarea} />
            <div style={{margin: '1rem'}}>
            <button className="submit" onClick={() => handleSendMessage()}>Invia messaggio alla Segretaria</button>
            </div>
        </Page>
    );
}
